import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import TabletTwoToneSvg from "@ant-design/icons-svg/es/asn/TabletTwoTone";
import AntdIcon from "../components/AntdIcon";
var TabletTwoTone = function TabletTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TabletTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  TabletTwoTone.displayName = 'TabletTwoTone';
}
export default /*#__PURE__*/React.forwardRef(TabletTwoTone);